import React from 'react';

/**
 * 사이드바 메뉴의 개별 아이템 컴포넌트.
 */
const SidebarMenuItem = ({ icon, label, isActive, onClick, isOpen }) => {
    if (!isOpen) {
        return (
            <div className="flex justify-center">
                <button
                    onClick={onClick}
                    title={label}
                    className={`h-1 flex items-center justify-center rounded-xl transition-all ${
                        isActive
                            ? 'bg-blue-600 text-white'
                            : 'text-gray-500 hover:bg-white hover:text-blue-600 hover:shadow-sm'
                    }`}
                >
                    {icon}
                </button>
            </div>
        );
    }

    return (
        <button
            onClick={onClick}
            className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl text-base font-bold transition-all ${
                isActive
                    ? 'bg-blue-600 text-white shadow-lg shadow-blue-100'
                    : 'text-gray-700 hover:bg-white hover:shadow-sm hover:text-blue-600'
            }`}
        >
            <div className={isActive ? 'text-white' : 'text-gray-500'}>{icon}</div>
            <span>{label}</span>
        </button>
    );
};

export default SidebarMenuItem;
